import {
  DIALOG_ERROR_OPEN,
  DIALOG_ERROR_CLOSE,
  DIALOG_LOGIN_OPEN,
  DIALOG_LOGIN_CLOSE,
  DIALOG_REGISTER_OPEN,
  DIALOG_REGISTER_CLOSE,
} from "./dialogTypes";

export const errorDialogOpen = (message) => {
  return {
    type: DIALOG_ERROR_OPEN,
    payload: message,
  };
};
export const errorDialogClose = (message) => {
  return {
    type: DIALOG_ERROR_CLOSE,
    payload: message,
  };
};

export const loginDialogOpen = (message) => {
  return {
    type: DIALOG_LOGIN_OPEN,
    payload: message,
  };
};
export const loginDialogClose = (message) => {
  return {
    type: DIALOG_LOGIN_CLOSE,
    payload: message,
  };
};

export const registerDialogOpen = (message) => {
  return {
    type: DIALOG_REGISTER_OPEN,
    payload: message,
  };
};

export const registerDialogClose = (message) => {
  return {
    type: DIALOG_REGISTER_CLOSE,
    payload: message,
  };
};
